<template>
  <div class='multi-tool-banner-wrapper'>
    <div class='multi-tool-wrapper'>
      <h1 class='multi-tool-title'>
        {{ $t('banners.cloudBannerDiscount.title') }}
      </h1>
      <span class='multi-tool-text'>
         {{ $t('banners.multiToolFacebook.registerAndTry') }}
        </span>
      <button class='register-button' @click='openLink'>
        {{ $t('banners.multiToolFacebook.register') }}
      </button>
    </div>
  </div>
</template>

<script>

import {
  EXPERIMENT_GROUP_NAME_B_RU_URL,
  EXPERIMENT_GROUP_NAME_B_EN_URL
} from '@/constants/experiments'

export default {
  name: 'CloudBannerB',

  methods: {
    openLink() {
      if (this.$i18n.locale === 'ru') {
        window.open(EXPERIMENT_GROUP_NAME_B_RU_URL, '_blank')
      } else {
        window.open(EXPERIMENT_GROUP_NAME_B_EN_URL, '_blank')
      }
    }
  }
}
</script>

<style scoped>
.multi-tool-banner-wrapper {
  border-radius: 24px;
  width: 100%;
  color: #FFFFFF;
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  font-family: Gilroy, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  height: 145px;
  font-weight: 600;
}

.multi-tool-wrapper {
  border-radius: 24px;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  background-size: contain;
  background: #0062E0 url("../../assets/cloud/girl_with_cloud.svg") no-repeat right;
}

.multi-tool-title {
  font-size: 22px;
  font-weight: 800;
  line-height: 26px;
  text-align: left;
}

.multi-tool-text {
  margin-top: 8px;
  font-size: 16px;
  line-height: 19px;
  text-align: left;
}

.register-button {
  padding: 8px 24px;
  border-radius: 100px;
  background: #E8FF63;
  color: #28334A;
  font-size: 16px;
  font-weight: 600;
  line-height: 112%;
  margin-top: 16px;
  white-space: nowrap;
  width: fit-content;
}

</style>